export const USERS_LIST_URL: string = 'user/list';
export const SEARCH_USERS: string = 'user/search';
export const SEARCH_DELIVERY_TEAM_MEMBERS_URL: string = 'user/search-delivery-team-members';
export const NEW_USER_URL: string = 'user';
export const GET_CURRENT_USER_URL: string = 'user/current';
export const GET_USER_URL: string = 'user/{username}';
export const EDIT_USER_URL: string = 'user/{username}';
export const DELETE_USER_URL: string = 'user/{username}';
export const EXPORT_USERS_URL: string = 'user/export';
export const ACCOUNT_USERS_URL: string = 'user/account-users/{accountId}';
export const ACTIVATE_USER_URL: string = 'user/{username}/active-status';
export const ACCOUNT_COORDINATORS_URL: string = 'user/search-coordinators';

export const EXPORT_CONNECTIONS_TEMPLATE_URL: string = 'user/export-template';
export const EDIT_EXPORT_CONNECTIONS_TEMPLATE_URL: string = 'user/export-template/{connectionExportTemplateId}';